<template>
  <baidu-map
    class="bm-view"
    :center="center"
    :zoom="zoom"
    ak="eYR8MAbMoY7kDSXoAThH0fCaHbBuZbi9"
    @ready="mapHandler"
  >
    <bm-marker
      v-for="item in stationList"
      :key="item.is"
      :position="{ lng: item.elecLng, lat: item.elecLat }"
      @click="clickHandler(item)"
    >
      <bm-label
        :content="item.elecName"
        :title="item.elecAdd"
        labelStyle="{ color: '#3c3c3c', fontSize: '12px'}"
        @click="clickHandler(item)"
        :offset="{ width: -35, height: 30 }"
      />
    </bm-marker>
    <bm-overview-map
      anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
      :isOpen="true"
    ></bm-overview-map>
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
  </baidu-map>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
// import BmPointCollection from "vue-baidu-map/components/overlays/PointCollection.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmOverviewMap from "vue-baidu-map/components/controls/OverviewMap.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation.vue";
export default {
  name: "Map",
  components: {
    BaiduMap,
    BmMarker,
    BmLabel,
    // BmPointCollection,
    BmOverviewMap,
    BmNavigation,
  },
  props: {
    stationList: {
      type: Array,
    },
  },
  data() {
    return {
      zoom: 3,
    };
  },
  computed: {
    center() {
      var center = {
        lng: 0,
        lat: 0,
      };
      var elecLatTotal = 0;
      var elecLngTotal = 0;
      this.stationList.forEach((station) => {
        elecLatTotal += station.elecLat;
        elecLngTotal += station.elecLng;
      });
      center.lng = (elecLngTotal / this.stationList.length).toFixed(2);
      center.lat = (elecLatTotal / this.stationList.length).toFixed(2);
      return center;
    },
    points() {
      var res = [];
      this.stationList.forEach((station) => {
        res.push({
          lng: station.elecLng,
          lat: station.elecLat,
          id: station.id,
        });
      });
      return res;
    },
  },
  methods: {
    //设置地图
    mapHandler() {
      this.zoom = 13;
    },
    //点击店
    clickHandler(station) {
      this.$emit("onSelect", station);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .BMapLabel {
    color: #000;
    background-color: aquamarine !important;
    border: 1px solid rgb(103, 216, 162) !important;
    border-radius: 2px !important;
  }
}
.bm-view {
  width: 100%;
  height: 100%;
}
</style>
